<template>
  <slot/>
</template>
